import {DirectiveBinding, VNode} from 'vue';

export default {
    mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode, prevVnode: VNode) {
        if (el.classList.contains('ant-dropdown-button')) {
            el.querySelector('.ant-btn')?.setAttribute('data-testid', binding.value);
        } else if (el.classList.contains('ant-select')) {
            el.setAttribute('data-testid', binding.value);
            el.querySelector('.ant-select-selection-search-input')?.setAttribute(
                'data-testid',
                binding.value + '_search'
            );
            el.querySelector('.ant-select-selection-item')?.setAttribute('data-testid', binding.value + '_value');
        } else if (el.classList.contains('ant-picker')) {
            el.querySelector('.ant-picker-input > input')?.setAttribute('data-testid', binding.value);
        } else {
            el.setAttribute('data-testid', binding.value);
        }
        // console.log('mounted', el, binding, vnode, prevVnode);
    }
};
